import { MediumContentWrapper } from '../ModuleContentWrapper'
import ModuleTitle from '../ModuleTitle'
import HTMLContent from 'components/common/HTMLContent'

const HTMLModule = ({ data, isServicePage = false }) => {
  return (
    <MediumContentWrapper $isServicePage={isServicePage}>
      {data?.customHtmlModule?.title && (
        <ModuleTitle title={data?.customHtmlModule?.title} />
      )}
      <HTMLContent content={data?.customHtmlModule?.content} />
    </MediumContentWrapper>
  )
}

export default HTMLModule
